// The loading state from connect-v2's PageContainer, used as the route Suspense fallback.
export function PageSkeleton() {
	return (
		<div className="flex flex-1 animate-pulse flex-col gap-4 px-4 py-4 md:px-6" aria-busy="true">
			<div>
				<div className="bg-muted mb-2 h-8 w-48 max-w-full rounded" />
				<div className="bg-muted h-4 w-64 max-w-full rounded" />
			</div>
			<div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
				{Array.from({ length: 4 }, (_, i) => (
					<div key={i} className="bg-muted h-24 rounded-xl" />
				))}
			</div>
			<div className="bg-muted h-40 w-full rounded-xl" />
		</div>
	);
}
